import { getManualFiltersFields } from '@/pages/alerts/models/alerts-controls'
import { allBlockchainCoin } from '@/assets/static/currency-list'
export default {
  getActiveManualFilters: state =>
    state.activeManualFilters ?? getManualFiltersFields(),
  getActiveBlockchain: state => state.activeBlockchain ?? allBlockchainCoin,
  getActiveSmartFilters: state => state.activeSmartFilters,
  getIsAISort: state => state.isAISort ?? false,
  getAlertsTypeFilter: state => state.alertsTypeFilter ?? [],
  getIsAlertDetailsShown: state => state.isAlertDetailsShown ?? false,
  getActiveAlertItem: state => state.activeAlertItem ?? {},
}
